import style from "./Proximamente.module.css"

const Proximamente = ({ handleRegister }) => {

    const featuresJugador = [
        {
            icon: "📍",
            titulo: "GPS Tracking en Vivo",
            descripcion: "Rastrea tu entrenamiento en tiempo real: distancia, velocidad, sprints, mapa de calor y mucho más. Tu celular se convierte en tu herramienta de rendimiento.",
            tag: "FASE 1"
        },
        {
            icon: "🧪",
            titulo: "Pruebas Físicas Guiadas",
            descripcion: "Realiza pruebas de velocidad, resistencia y salto usando los sensores de tu dispositivo. Cronometraje automático, resultados precisos y video de evidencia.",
            tag: "FASE 1"
        },
        {
            icon: "🏆",
            titulo: "Logros, Niveles y Retos",
            descripcion: "Gana XP, desbloquea insignias y sube de nivel. Compite en retos semanales y escala en los leaderboards por posición, edad y ciudad.",
            tag: "FASE 1"
        },
        {
            icon: "🤖",
            titulo: "Análisis con Inteligencia Artificial",
            descripcion: "Recibe un análisis semanal personalizado de tu rendimiento. La IA identifica tus fortalezas, áreas de mejora y te recomienda rutinas de entrenamiento.",
            tag: "FASE 3"
        },
        {
            icon: "📋",
            titulo: "CV Deportivo Digital",
            descripcion: "Tu perfil verificado con métricas, estadísticas, videos y evaluaciones en una URL compartible. Expórtalo a PDF o compártelo con un QR.",
            tag: "FASE 4"
        },
        {
            icon: "📊",
            titulo: "Score Predictivo",
            descripcion: "Visualiza cómo evolucionará tu BSD Score si mantienes tu ritmo actual. Recibe metas concretas para subir de nivel.",
            tag: "FASE 3"
        },
    ]

    const featuresEntrenador = [
        {
            icon: "👥",
            titulo: "Gestión de Equipos",
            descripcion: "Crea tu equipo, invita jugadores con un código y gestiona tu plantel completo desde un solo lugar. Dorsales, posiciones y estadísticas de cada jugador.",
            tag: "FASE 2"
        },
        {
            icon: "📝",
            titulo: "Evaluaciones Estructuradas",
            descripcion: "Evalúa a tus jugadores después de cada partido o entrenamiento. Califica técnica, táctica, físico y mentalidad con comentarios privados.",
            tag: "FASE 2"
        },
        {
            icon: "📅",
            titulo: "Convocatorias y Asistencia",
            descripcion: "Programa entrenamientos y partidos. Tus jugadores confirman asistencia desde la app y tú controlas quién asistió.",
            tag: "FASE 2"
        },
        {
            icon: "📈",
            titulo: "Dashboard de Rendimiento",
            descripcion: "Visualiza el rendimiento de todo tu equipo: quién mejora, quién necesita atención, asistencia promedio y BSD Score grupal.",
            tag: "FASE 2"
        },
        {
            icon: "🤖",
            titulo: "Reportes IA por Jugador",
            descripcion: "Recibe análisis automáticos de cada jugador de tu plantilla. Identifica patrones de mejora y compara con promedios por posición.",
            tag: "FASE 3"
        },
        {
            icon: "📤",
            titulo: "Exportar Datos",
            descripcion: "Descarga reportes de rendimiento de tu equipo. Comparte informes con directivos, padres de familia o scouts interesados.",
            tag: "FASE 4"
        },
    ]

    const timeline = [
        {
            fase: "FASE 1",
            titulo: "App Nativa + GPS Tracking + Gamificación",
            subtitulo: "Valor inmediato para el jugador",
            semanas: "Semanas 1-8",
            estado: "proximo",
            icono: "📍",
            color: "#E4FD3F",
            features: [
                { nombre: "App móvil para Android e iOS", desc: "Una app rápida, fluida y disponible en ambas tiendas, que aprovecha al máximo las capacidades de tu celular" },
                { nombre: "GPS Tracking en vivo", desc: "Distancia, velocidad, sprints, mapa de calor y clasificación de actividad en tiempo real" },
                { nombre: "Pruebas físicas guiadas", desc: "Sprint 50m, resistencia 3km y salto vertical usando sensores del celular" },
                { nombre: "Sistema de gamificación", desc: "Logros, insignias, niveles (Novato → Élite), retos semanales y leaderboards" },
            ],
            tecnologias: ["Expo SDK", "GPS", "Acelerómetro", "React Native Maps"],
            metaClave: "Que el jugador obtenga valor SIN necesitar entrenadores en la plataforma"
        },
        {
            fase: "FASE 2",
            titulo: "Herramientas para Entrenadores",
            subtitulo: "Gestión profesional de equipos",
            semanas: "Semanas 6-14",
            estado: "proximo",
            icono: "👥",
            color: "#E4FD3F",
            features: [
                { nombre: "Sistema de equipos", desc: "Crear equipo, invitar jugadores con código, dorsales, posiciones y dashboard grupal" },
                { nombre: "Evaluaciones estructuradas", desc: "Calificar técnica, táctica, físico y mentalidad con comentarios privados por jugador" },
                { nombre: "Convocatorias y asistencia", desc: "Programar partidos/entrenamientos, confirmación de asistencia y recordatorios push" },
                { nombre: "Dashboard de rendimiento", desc: "Visualizar quién mejora, quién necesita atención, asistencia promedio y BSD Score grupal" },
            ],
            tecnologias: ["Socket.io", "Push Notifications", "Dashboard Analytics"],
            metaClave: "Los entrenadores vienen porque sus jugadores ya están en la plataforma"
        },
        {
            fase: "FASE 3",
            titulo: "Inteligencia Artificial y Análisis",
            subtitulo: "Insights que antes solo tenían los profesionales",
            semanas: "Semanas 12-20",
            estado: "futuro",
            icono: "🤖",
            color: "#8B5CF6",
            features: [
                { nombre: "Análisis semanal con IA", desc: "Reporte personalizado de rendimiento: fortalezas, áreas de mejora y recomendaciones" },
                { nombre: "Rutinas personalizadas", desc: "La IA selecciona ejercicios de una BD según tus debilidades y genera rutinas a medida" },
                { nombre: "Análisis de video con IA", desc: "Sube un video y recibe feedback de postura, técnica de carrera y posicionamiento" },
                { nombre: "BSD Score Predictivo", desc: "Predicción de evolución del score con metas concretas para subir de nivel" },
            ],
            tecnologias: ["OpenAI / Claude API", "Machine Learning", "Computer Vision"],
            metaClave: "Análisis profesional accesible para cualquier jugador amateur"
        },
        {
            fase: "FASE 4",
            titulo: "Contenido, CV Digital y Comunidad",
            subtitulo: "Destino diario con valor constante",
            semanas: "Semanas 18-26",
            estado: "futuro",
            icono: "📋",
            color: "#3B82F6",
            features: [
                { nombre: "CV Deportivo Digital", desc: "Perfil verificado con métricas, estadísticas y videos en URL compartible, PDF y QR" },
                { nombre: "Feed de contenido deportivo", desc: "Resultados de Liga MX, tips de entrenamiento, videos educativos y noticias" },
                { nombre: "Retos y competencias", desc: "Retos individuales semanales, desafíos globales mensuales y competencias entre equipos" },
                { nombre: "Integración Health", desc: "Sincronización con Apple HealthKit y Google Fit para datos de salud y actividad" },
            ],
            tecnologias: ["APIs deportivas", "jsPDF", "QR Code", "HealthKit"],
            metaClave: "Crear loops de crecimiento virales: compartir logros → nuevos usuarios"
        },
        {
            fase: "Y MÁS...",
            titulo: "Esto es solo el comienzo",
            subtitulo: "Estamos planeando muchas más funcionalidades basándonos en lo que la comunidad necesita",
            semanas: "Próximamente",
            estado: "futuro",
            icono: "🚀",
            color: "#F59E0B",
            features: [
                { nombre: "Planes premium con beneficios exclusivos", desc: "Acceso a herramientas avanzadas, análisis ilimitados y funcionalidades especiales para quienes quieran ir al siguiente nivel" },
                { nombre: "Alianzas con academias y clubes", desc: "Colaboraciones con escuelas de fútbol y equipos para llevar la plataforma a más jugadores" },
                { nombre: "Nuevas funcionalidades según tu feedback", desc: "Tú decides qué construimos. Las próximas features se definirán con la comunidad de usuarios" },
                { nombre: "Expansión a más deportes y regiones", desc: "El objetivo es llevar esta tecnología a toda Latinoamérica y más allá del fútbol" },
            ],
            tecnologias: ["Tu feedback", "Comunidad", "Innovación continua"],
            metaClave: "Lo mejor está por venir — y tú puedes ser parte de construirlo"
        },
    ]

    return (
        <div className={style.container}>
            {/* HERO */}
            <div className={style.hero}>
                <div className={style.heroContent}>
                    <div className={style.tagProximamente}>PROXIMAMENTE</div>
                    <h1 className={style.heroTitle}>EL FUTURO DEL FÚTBOL AMATEUR ESTÁ AQUÍ</h1>
                    <p className={style.heroSub}>Estamos construyendo la plataforma de rendimiento más avanzada para jugadores y entrenadores. Tecnología que antes solo tenían los profesionales, ahora en tu bolsillo.</p>
                    <button className={style.btnHero} onClick={handleRegister}>Regístrate y sé el primero</button>
                </div>
                <div className={style.heroVisual}>
                    <div className={style.mockupPhone}>
                        <div className={style.phoneScreen}>
                            <div className={style.phoneHeader}>
                                <span className={style.phoneDot}></span>
                                <span className={style.phoneTitle}>ENTRENAMIENTO EN CURSO</span>
                            </div>
                            <div className={style.phoneMetric}>
                                <span className={style.phoneMetricValue}>12.3</span>
                                <span className={style.phoneMetricUnit}>km/h</span>
                            </div>
                            <div className={style.phoneStats}>
                                <div className={style.phoneStat}>
                                    <span className={style.phoneStatValue}>4.2 km</span>
                                    <span className={style.phoneStatLabel}>Distancia</span>
                                </div>
                                <div className={style.phoneStat}>
                                    <span className={style.phoneStatValue}>7</span>
                                    <span className={style.phoneStatLabel}>Sprints</span>
                                </div>
                                <div className={style.phoneStat}>
                                    <span className={style.phoneStatValue}>28.4</span>
                                    <span className={style.phoneStatLabel}>Vel. Máx</span>
                                </div>
                            </div>
                            <div className={style.phoneBar}></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* PARA JUGADORES */}
            <div className={style.section}>
                <div className={style.sectionHeader}>
                    <div className={style.sectionTag}>PARA JUGADORES</div>
                    <h2 className={style.sectionTitle}>MIDE, MEJORA Y DEMUESTRA TU TALENTO</h2>
                    <p className={style.sectionSub}>Herramientas profesionales de tracking y análisis que te ayudan a entrenar mejor, medir tu progreso real y mostrar tu nivel con datos verificados.</p>
                </div>
                <div className={style.featuresGrid}>
                    {featuresJugador.map((feature, index) => (
                        <div className={style.featureCard} key={index}>
                            <div className={style.featureTop}>
                                <span className={style.featureIcon}>{feature.icon}</span>
                                <span className={style.featureTag}>{feature.tag}</span>
                            </div>
                            <h3 className={style.featureTitle}>{feature.titulo}</h3>
                            <p className={style.featureDesc}>{feature.descripcion}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* PARA ENTRENADORES */}
            <div className={style.sectionCoach}>
                <div className={style.sectionHeader}>
                    <div className={style.sectionTagCoach}>PARA ENTRENADORES</div>
                    <h2 className={style.sectionTitle}>GESTIONA TU EQUIPO COMO PROFESIONAL</h2>
                    <p className={style.sectionSub}>Todo lo que necesitas para administrar tu equipo, evaluar jugadores y tomar decisiones basadas en datos reales de rendimiento.</p>
                </div>
                <div className={style.featuresGrid}>
                    {featuresEntrenador.map((feature, index) => (
                        <div className={style.featureCardCoach} key={index}>
                            <div className={style.featureTop}>
                                <span className={style.featureIcon}>{feature.icon}</span>
                                <span className={style.featureTagCoach}>{feature.tag}</span>
                            </div>
                            <h3 className={style.featureTitle}>{feature.titulo}</h3>
                            <p className={style.featureDesc}>{feature.descripcion}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* TIMELINE / ROADMAP */}
            <div className={style.timelineSection}>
                <div className={style.timelineHeader}>
                    <div className={style.timelineTag}>ROADMAP</div>
                    <h2 className={style.timelineTitle}>ROADMAP DE DESARROLLO</h2>
                    <p className={style.timelineSub}>Nuestro plan de 8 meses para convertir BigSportData en la plataforma de rendimiento #1 en Latinoamérica. 5 fases, de lo esencial a lo extraordinario.</p>
                    <div className={style.timelineBar}>
                        <div className={style.timelineBarProgress}></div>
                        <div className={style.timelineBarLabels}>
                            <span>INICIO</span>
                            <span>SEMANA 8</span>
                            <span>SEMANA 16</span>
                            <span>SEMANA 24</span>
                            <span>Y MÁS...</span>
                        </div>
                    </div>
                </div>

                <div className={style.roadmapGrid}>
                    {timeline.map((item, index) => (
                        <div className={`${style.roadmapCard} ${item.estado === 'proximo' ? style.roadmapCardProximo : style.roadmapCardFuturo}`} key={index}>
                            <div className={style.roadmapCardHeader}>
                                <div className={style.roadmapCardTop}>
                                    <span className={style.roadmapIcon}>{item.icono}</span>
                                    <div className={style.roadmapBadges}>
                                        <span className={style.roadmapFaseTag} style={{ borderColor: item.color, color: item.color }}>{item.fase}</span>
                                        <span className={style.roadmapSemanas}>{item.semanas}</span>
                                    </div>
                                </div>
                                <h3 className={style.roadmapCardTitle}>{item.titulo}</h3>
                                <p className={style.roadmapCardSubtitle}>{item.subtitulo}</p>
                            </div>

                            <div className={style.roadmapFeatures}>
                                {item.features.map((feature, fIndex) => (
                                    <div className={style.roadmapFeature} key={fIndex}>
                                        <div className={style.roadmapFeatureDot} style={{ backgroundColor: item.color }}></div>
                                        <div className={style.roadmapFeatureContent}>
                                            <span className={style.roadmapFeatureName}>{feature.nombre}</span>
                                            <span className={style.roadmapFeatureDesc}>{feature.desc}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className={style.roadmapCardFooter}>
                                <div className={style.roadmapTechs}>
                                    {item.tecnologias.map((tech, tIndex) => (
                                        <span className={style.roadmapTechPill} key={tIndex}>{tech}</span>
                                    ))}
                                </div>
                                <div className={style.roadmapMeta}>
                                    <span className={style.roadmapMetaLabel}>META CLAVE</span>
                                    <p className={style.roadmapMetaText}>{item.metaClave}</p>
                                </div>
                            </div>

                            {item.estado === 'proximo' && <div className={style.roadmapCardGlow} style={{ background: `radial-gradient(ellipse at top, ${item.color}08 0%, transparent 70%)` }}></div>}
                        </div>
                    ))}
                </div>

            </div>

            {/* CTA FINAL */}
            <div className={style.ctaSection}>
                <h2 className={style.ctaTitle}>NO TE QUEDES FUERA</h2>
                <p className={style.ctaSub}>Regístrate ahora y sé de los primeros en acceder a las nuevas funcionalidades cuando se lancen. Los primeros usuarios tendrán beneficios exclusivos.</p>
                <button className={style.btnCta} onClick={handleRegister}>Crear mi cuenta gratis</button>
            </div>
        </div>
    )
}

export default Proximamente
